declare global {
    interface Array<T> {
        moveLabelToMiddle<K extends keyof T>(labelKey: K, labelValue: T[K]): Array<T>
        orderFooterAndCenterDoti<K extends keyof T>(labelKey: K, labelValue: T[K]): Array<T>
    }
}

Array.prototype.moveLabelToMiddle = function <T, K extends keyof T>(this: Array<T>, labelKey: K, labelValue: T[K]): Array<T> {
    const index = this.findIndex((item) => item[labelKey] === labelValue)

    if (index === -1) return this

    const [obj] = this.splice(index, 1)
    const middle = Math.floor(this.length / 2)
    this.splice(middle, 0, obj)

    return this
}

Array.prototype.orderFooterAndCenterDoti = function <T, K extends keyof T>(this: Array<T>, labelKey: K, labelValue: T[K]): Array<T> {
    // 0. FILTRAR SOLO ITEMS DEL FOOTER (nav y section estrictamente 0 o false)
    const footerItems = this.filter((item: any) => (item.nav === 0 || item.nav === false) && (item.section === 0 || item.section === false))

    if (footerItems.length === 0) return []

    // 1. ORDENAR POR INDEX SI EXISTE
    const hasIndex = footerItems.some((item) => (item as any)['index'] !== undefined)

    if (hasIndex) {
        footerItems.sort((a: any, b: any) => {
            const aHas = a['index'] !== undefined
            const bHas = b['index'] !== undefined

            if (aHas && bHas) return a['index'] - b['index']
            if (aHas) return -1
            if (bHas) return 1
            return 0
        })
    }

    // 2. Buscar Doti
    let index = footerItems.findIndex((item) => item[labelKey] === labelValue)

    if (index === -1) return footerItems

    // 3. Si la cantidad es par → agregar ProfileScreen
    if (footerItems.length % 2 === 0) {
        footerItems.push({
            _id: 'profile-screen-placeholder',
            icon: '',
            name: '',
            label: 'Profile',
            nav: 0,
            section: 0,
        } as any)
    }

    // 4. Recalcular índice de Doti
    index = footerItems.findIndex((item) => item[labelKey] === labelValue)

    // 5. Extraer Doti
    const [obj] = footerItems.splice(index, 1)

    // 6. Ubicar en el centro real
    const middle = Math.floor(footerItems.length / 2)

    footerItems.splice(middle, 0, obj)

    return footerItems
}
